import { render, staticRenderFns } from "./CompaniesPage.vue?vue&type=template&id=606ccc0d&"
import script from "./CompaniesPage.vue?vue&type=script&lang=js&"
export * from "./CompaniesPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports